/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PaymentDetails } from "./PaymentDetails";
import { PaymentOverview } from "./PaymentOverview";
import { debounce, receivingCountryData } from "../../utils";
import { Modals } from "./Modals";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  panDeclaration,
  selectedPurpose,
  selectVendor,
  showTimerText,
  transactionDetails,
  vendorCodes,
} from "../../store";
import { bookRate, fxRates, getTransactionSummary } from "../../services/remittance";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/ui/Loader";
import { callRatesApi } from "../../services/margin";
import { useIdleTimeout } from "../../hooks/useIdleTimeout";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import ShareQuoteModal from "../../components/ui/Modal/ShareQuoteModal";
import MixpanelConfig from "../../constants/MixpanelConfig";

const Amount = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const navigate = useNavigate();
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const [sendingAmount, setSendingAmount] = React.useState<number>(
    transactionData?.user_send ?? 10000
  );
  const [receivingAmount, setReceivingAmount] = React.useState<any>();
  const purpose = useRecoilValue(selectedPurpose);
  const [rate, setRate] = useState<number | "">(0);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [isPurposeModalOpen, setIsPurposeModalOpen] = useState(false);
  const [isPanModelOpen, setIsPanModelOpen] = useState(false);
  const [destCurrency, setDestCurrency] = useState<string>(
    localStorage.getItem("destCurr") ?? "USD"
  );
  const [nostro, setNostro] = useState<string>("our");
  const [tcs, setTcs] = useState<any>();
  const [isTcsPresent, setIsTcsPresent] = useState<boolean>(false);
  const [pan, setPan] = useState<string>("");
  const panDeclarationValue = useRecoilValue(panDeclaration);
  const [declareAmount, setDeclareAmount] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isEducation, setIsEducation] = useState<boolean>(() => {
    const storedValue = localStorage.getItem("isEducation");
    return storedValue === "false" ? false : storedValue === "true" ? true : false;
  });
  const [isErrorPresent, setIsErrorPresent] = useState<boolean>(false);
  const [receiveLocked, setReceiveLocked] = useState<boolean>(false);
  const [isBene, setIsBene] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const baseCurrency = "INR";
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor);
  const [moneySendViaMoneyhop, setMoneySentViaMoneyhop] = useState<number>(0);
  const [enableDecalreAmount, setEnableDeclareAmount] = useState<boolean>(false);
  const [modalLoading, setModalLoading] = useState<boolean>(false);
  const [firstTimeLoanPopup, setFirstTimeLoanPopup] = useState<boolean>(false);
  const [cardRates, setCardRates] = useState([]);
  const [onChangeHandlerType, setOnChangeHandleType] = React.useState<string>("send");
  // const [summaryLoading, setSummaryLoading] = React.useState<boolean>(false);
  const [tempPan, setTempPan] = useState("");
  const [showQuoteModal, setShowQuoteModal] = useState<boolean>(false);

  const idToken = localStorage.getItem("userToken") || "";
  const userKey = localStorage.getItem("userKey") || "";
  // const timer = Number(process.env.REACT_APP_SEND_MONEY_TIMER)|| 300000;
  const setShowTimerModal = useSetRecoilState(showTimerText);

  const prevValuesRef = useRef({
    sendingAmount: 0 as number,
    receivingAmount: 0 as number,
    purposeValue: "" as string | null,
    receiveCurrency: "" as string,
    sendingCurrency: "" as string,
    rate: 0 as number,
    vendorCode: "" as string,
    isPanModelOpen: false as boolean,
    isEducation: (() => {
      const storedValue = localStorage.getItem("isEducation");
      return storedValue === "false" ? false : storedValue === "true" ? true : false;
    })(),
    declareAmount: 0 as number,
    panDeclarationValue: "" as string,
    isBene: false as boolean,
    nostro: "our" as string,
  });

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (purpose?.purposeValue) {
      getCardRatesApi();
    }
  }, [purpose?.purposeValue]);

  useEffect(() => {
    if (receiveLocked) {
      setOnChangeHandleType("receive");
      localStorage.setItem("onChangeHandler", "receive");
    } else {
      setOnChangeHandleType("send");
      localStorage.setItem("onChangeHandler", "send");
    }
  }, [receiveLocked]);

  const lockConversionRate = async () => {
    // setLoading(true);
    const body = {
      userKey: userKey,
      baseCurrency: baseCurrency,
      destCurrency: destCurrency,
    };
    bookRate(body, idToken)
      .then((response) => {
        setErrorMessage("");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(err?.response?.data?.error?.type);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const proceedClick = () => {
    MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_SendMoney_Proceed, {
      transactionData: transactionData,
    });
    if (
      purpose?.purposeValue === "Overseas Education - University Fees" ||
      purpose?.purposeValue === "Overseas Education - Living Expenses"
    ) {
    }
    sessionStorage.setItem("hasSeenLoanPopup", "true");
    localStorage.setItem("purposeVal", purpose?.purposeValue);
    toast.success("Directing you to Remitter List");
    setTimeout(() => {
      navigate("/remitter");
    }, 1500);
    setShowTimerModal(true);
    lockConversionRate();
  };

  const handlePanBasedClick = () => {
    setIsPanModelOpen(true);
  };

  useEffect(() => {
    const code = purpose?.purposeCode;
    if (code === "S1301" || code === "S1302") {
      setNostro("bene");
    } else if (code === "S0305" && nostro !== "bene") {
      setNostro("our");
    } else {
      setNostro(nostro === "our" ? "bene" : "our");
    }
  }, [purpose?.purposeCode]);

  // useMemo(() => {
  //   !isErrorPresent && setErrorMessage("");
  // }, [isErrorPresent]);

  useEffect(() => {
    if (!isPanModelOpen) {
      setEnableDeclareAmount(false);
      // setMoneySentViaMoneyhop(0);
    } else if (isPanModelOpen) {
      setEnableDeclareAmount(true);
    }
  }, [isPanModelOpen]);

  useEffect(() => {
    // Only store `true` or `false` in localStorage, as stringified booleans
    if (isEducation !== null) {
      localStorage.setItem("isEducation", JSON.stringify(isEducation));
    }

    // Handle other storage items like `tcs`
    localStorage.setItem("tcs", tcs);
  }, [isEducation, tcs]);

  useEffect(() => {
    const isEducationPurpose =
      purpose?.purposeValue === "Overseas Education - University Fees" ||
      purpose?.purposeValue === "Overseas Education - Living Expenses";

    const hasSeen = sessionStorage.getItem("hasSeenLoanPopup");

    if (isEducationPurpose && hasSeen === "false") {
      setIsModalOpen("loan");
    } else {
      setIsModalOpen("");
    }
  }, [purpose?.purposeValue]);

  useEffect(() => {
    // Purpose dropdown has been interacted with
    if (isPurposeModalOpen) {
      sessionStorage.setItem("hasSeenLoanPopup", "false");
    }
  }, [isPurposeModalOpen]);

  const latestRequestRef = useRef(0);

  useEffect(() => {
    const shouldRun =
      (onChangeHandlerType === "send" && sendingAmount !== undefined) ||
      (onChangeHandlerType === "receive" && receivingAmount !== undefined);
    if (!shouldRun) return;

    localStorage.setItem("onChangeHandler", onChangeHandlerType);

    const requestId = ++latestRequestRef.current;

    const delayDebounce = setTimeout(() => {
      setErrorMessage(""); // reset before API
      setIsErrorPresent(false); // reset before API
      // setLoading(true);

      const body =
        onChangeHandlerType === "send" && !receiveLocked
          ? { user_send: sendingAmount }
          : { reciepient_recieve: receivingAmount };

      const nostroBody =
        nostro === "our" ? { isBene: false } : nostro === "bene" ? { isBene: true } : {};

      getTransactionSummary(
        {
          ...body,
          ...nostroBody,
          transVendorKey: vendorCode?.userId,
          base_currency: baseCurrency,
          dest_currency: destCurrency,
          hop_coins: 0,
          isEducation: isEducation,
          pan_number: panDeclarationValue,
          purposeCode: purpose?.purposeCode,
          vendor_key: currentUser.vendor_key,
          transaction_purpose: purpose?.purposeValue,
          conversion_rate: rate || "",
          declare_amount: declareAmount ?? 0,
          referrerVendor: vendorCode?.vendorCode,
        },
        idToken
      )
        .then((response) => {
          if (requestId !== latestRequestRef.current) return; // ignore stale

          setTransactionData((prev) => ({
            ...prev,
            ...response?.data,
            transactionLeadIds: {
              ...prev.transactionLeadIds,
              ...(response?.data?.transactionLeadIds || {}),
            },
          }));

          if (onChangeHandlerType === "send")
            setReceivingAmount(response?.data?.reciepient_recieve);
          else setSendingAmount(response?.data?.user_send);

          setMoneySentViaMoneyhop(response?.data?.money_sent_via_moneyhop_in_current_year);

          if (response?.data?.tcs > 0) {
            setIsTcsPresent(true);
            setTcs(response?.data?.tcs);
          } else setIsTcsPresent(false);

          setLoading(false);
        })
        .catch((error) => {
          if (requestId !== latestRequestRef.current) return; // ignore stale

          const errorMsg = error?.response?.data?.error?.type || "Something went wrong";
          setIsErrorPresent(true);
          setErrorMessage(errorMsg);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [
    sendingAmount,
    receivingAmount,
    baseCurrency,
    destCurrency,
    purpose?.purposeCode,
    purpose?.purposeValue,
    onChangeHandlerType,
    vendorCode,
    rate,
    nostro,
    isEducation,
    isPanModelOpen,
    panDeclarationValue,
    declareAmount,
    isBene,
    receiveLocked,
  ]);

  const getCardRatesApi = async () => {
    const req = await callRatesApi();
    const res = await req?.data;
    if (res) {
      setCardRates(res?.cardRate);
    }
  };

  const getFxRates = () => {
    fxRates(destCurrency).then((response) => {
      const marginValue =
        purpose?.purposeCode === "S1302"
          ? response?.data?.margin_value_gift ?? 0
          : purpose?.purposeCode === "S1301"
          ? response?.data?.margin_value_maintanence ?? 0
          : response?.data?.margin_value ?? 0;

      const vendorMarginValue =
        purpose?.purposeCode === "S1302"
          ? response?.data?.vendor_margin_value_gift ?? 0
          : purpose?.purposeCode === "S1301"
          ? response?.data?.vendor_margin_value_maintanence ?? 0
          : response?.data?.vendor_margin_value ?? 0;

      const totalRate: any =
        parseFloat(response.data.ibr) + parseFloat(marginValue) + parseFloat(vendorMarginValue);
      setRate(parseFloat(totalRate.toFixed(4)));
    });
  };

  useEffect(() => {
    localStorage.setItem("destCurr", destCurrency);
  }, [destCurrency]);

  useEffect(() => {
    getFxRates();
  }, [purpose?.purposeCode, destCurrency]);

  // const handleTimeout = ()=>{
  //   toast.success("Rates refreshed.", { containerId: "top-right-toast" });
  //   setShowToast(true);
  //   console.log("triggereed")
  //   toast.success("Rates refreshed.", { containerId: "top-right-toast", position: "top-right", autoClose: 5000, pauseOnFocusLoss: true });
  //   debouncedSendTransferSummary(sendingAmount, destCurrency);
  // }

  // const { isIdle, remainingTime } = useIdleTimeout({
  //   timeout: 300000,
  //   // timeout: 5_000,
  //   onTimeout: handleTimeout
  // });

  return (
    <div className="flex w-full h-full justify-center mx-auto scale-[0.8] -mt-16">
      <ToastContainer position="top-center" />
      <PaymentOverview
        sendingAmount={sendingAmount}
        recievingAmount={receivingAmount}
        sendingCurrency={"INR"}
        recieivingCurrency={destCurrency}
        setSendingAmount={setSendingAmount}
        setReceivingAmount={setReceivingAmount}
        purposeCode={purpose?.purposeCode}
        rate={rate}
        setRate={setRate}
        proceedClick={proceedClick}
        destCurrency={destCurrency}
        setIsModalOpen={setIsModalOpen}
        setIsPurposeModalOpen={setIsPurposeModalOpen}
        base_currency={baseCurrency}
        errorMessage={errorMessage}
        setErrorMessage={(error: any) => setErrorMessage(error)}
        purposeValue={purpose?.purposeValue}
        // sendTransferSummary={sendTranferSummary}
        // rateTransferSummary={rateTransferSummary}
        // receiveTransferSummary={receiveTransferSummary}
        isErrorPresent={isErrorPresent}
        receiveLocked={receiveLocked}
        setReceiveLocked={setReceiveLocked}
        cardRates={cardRates}
        setFirstTimeLoanPopup={setFirstTimeLoanPopup}
        firstTimeLoanPopup={firstTimeLoanPopup}
        loading={loading}
        tcs={tcs}
        setOnChangeHandleType={setOnChangeHandleType}
        setDestCurrency={setDestCurrency}
      />
      <div className="w-1 h-[750px] border-4 border-r mx-16"></div>
      <PaymentDetails
        recievingAmount={receivingAmount}
        nostro={nostro}
        setNostro={setNostro}
        handlePanBasedClick={handlePanBasedClick}
        // handleGeneralClick={handleGeneralClick}
        setIsModalOpen={setIsModalOpen}
        setIsPanModelOpen={setIsPanModelOpen}
        setPan={setPan}
        pan={pan}
        purposeCode={purpose?.purposeCode}
        setIsErrorPresent={setIsErrorPresent}
        loading={loading}
        isErrorPresent={isErrorPresent}
        sendingAmount={sendingAmount}
        destCurrency={destCurrency}
        proceedClick={proceedClick}
        rate={rate}
        purposeValue={purpose?.purposeValue}
        setTempPan={setTempPan}
        setShowQuoteModal={setShowQuoteModal}
        showQuoteModal={showQuoteModal}
      />
      <Modals
        isModalOpen={isModalOpen}
        isPurposeModalOpen={isPurposeModalOpen}
        setIsModalOpen={setIsModalOpen}
        isPanModelOpen={isPanModelOpen}
        setIsPanModelOpen={setIsPanModelOpen}
        setIsPurposeModalOpen={setIsPurposeModalOpen}
        receivingCountryModalData={receivingCountryData}
        destCurrency={destCurrency}
        setDestCurrency={setDestCurrency}
        purposeCode={purpose?.purposeCode}
        setFirstTimeLoanPopup={setFirstTimeLoanPopup}
        setPan={setPan}
        firstTimeLoanPopup={firstTimeLoanPopup}
        setIsEducation={setIsEducation}
        // sendTransferSummary={sendTranferSummary}
        sendingAmount={sendingAmount}
        errorMessage={errorMessage}
        tcs={tcs}
        setDeclareAmount={setDeclareAmount}
        moneySendViaMoneyhop={moneySendViaMoneyhop}
        enableDecalreAmount={enableDecalreAmount}
        modalLoading={modalLoading}
        setEnableDeclareAmount={setEnableDeclareAmount}
        declareAmount={declareAmount}
        setTcs={setTcs}
        tempPan={tempPan}
        setTempPan={setTempPan}
      />
    </div>
  );
};

export default Amount;
